import { db } from '../fbConnect'

var error = []

const fbActions = {
	get: (url, params) => {
		if (url) {
			if (params.id) {
				return db.collection(url).doc(params.id).get()
			} else {
				var queryRef = db.collection(url)
				if (params.filter) {
					var filters = params.filter
					if (filters.where) {
						filters.where.forEach(w => {
							queryRef = queryRef.where(w[0], w[1], w[2])
						})
					}
					if (filters.orderBy) {
						filters.orderBy.forEach(o => {
							o[1] ? queryRef = queryRef.orderBy(o[0], o[1]) : queryRef = queryRef.orderBy(o[0])
						})
					}
					
					if (filters.startAfter) {
						queryRef = queryRef.startAfter(filters.startAfter)
					}

					if (filters.startAt) {
						filters.startAt[1] ? queryRef = queryRef.startAt(filters.startAt[0], filters.startAt[1]) : queryRef = queryRef.startAt(filters.startAt[0])
					}

					if (filters.endAt) {
						filters.endAt[1] ? queryRef = queryRef.endAt(filters.endAt[0], filters.endAt[1]) : queryRef = queryRef.endAt(filters.endAt[0])
					}

					if (filters.limit) {
						queryRef = queryRef.limit(filters.limit)
					}
					
					
					return queryRef.get()
				} else {
					
					return queryRef.get()
				}
			}
		} else {
			error.push('No existe la siguiente url: ' + url)
		}
		if (error.length > 0) console.log(error)
	},
	post(url, params) {
		if (url) {
			if (!params.id) {
				if (params.data) {
					return db.collection(params.url).add(params.data)
				} else {
					error.push('No hay datos que añadir en la base de datos')
				}
			} else {
				error.push('No puedo y/o no debería crear un registro con este ID ' + params.id)
			}
		} else {
			error = 'No existe la siguiente url: ' + url
		}
		if (error.length > 0){
			console.log(error)
			return false
		}
	},
	put(url, params) {
		if (url) {
			if (params.id) {
				if (params.data) {
					return db.collection(params.url).doc(params.id).update(params.data)
				} else {
					error.push('No hay datos que añadir en la base de datos')
				}
			} else {
				error.push('No hay ID para actualizar ' + params.id)
			}
		} else {
			error = 'No existe la siguiente url: ' + url
		}
		if (error.length > 0){
			console.log(error)
			return false
		}
	},
	removeField(url, params) {
		if (url) {
			if (params.id) {
				if (params.data) {
					return db.collection(params.url).doc(params.id).update({
							// params.data: db.FieldValue.delete()
						}
					)
				} else {
					error.push('No hay datos que añadir en la base de datos')
				}
			} else {
				error.push('No hay ID para actualizar ' + params.id)
			}
		} else {
			error = 'No existe la siguiente url: ' + url
		}
		if (error.length > 0){
			console.log(error)
			return false
		}
	},
	delete(url, params) {
		if (url) {
			return db.collection(url).doc(params.id).delete()
		} else {
			error = 'No existe la siguiente url: ' + url
			console.log(error)
		}
	}
}

export { fbActions }
